import "../Info/Schedule/SiteConfigurationGroupScheduleInfoComponent";
import "./Edit/ConfigurationGroupRecordingEditComponent";
import "./SiteConfigurationGroupRecording.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteConfigurationGroupRecordingComponentController from "./SiteConfigurationGroupRecordingComponentController";

export class SiteConfigurationGroupRecordingComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            configurationGroup: "<",
            deleted: "&?",
            site: "<",
        };
        this.controller = SiteConfigurationGroupRecordingComponentController;
        this.templateUrl = "/App/Components/Site/ConfigurationGroups/Recording/SiteConfigurationGroupRecording.html";
    }
}

module("mmManagePortal").component("mmSiteConfigurationGroupRecording", new SiteConfigurationGroupRecordingComponent());
